<template lang="pug">
  .component-reveal-void
    ModalReveal
      button.button.danger(slot="trigger") Billed Records
      .header(slot="header")
        h2 Records &nbsp;
          strong INV{{invoice.internal_id}}({{invoice.id}})
      BilledRecords(:item="invoice")
</template>
<script type="text/babel">
  import ModalReveal from '../../../foundation/ModalReveal'
  import InputSwitch from '../../InputSwitch'
  import ActionButton from '../../ActionButton'
  import Transaction from '../../../../backoffice/Transaction'
  import BaseList from '../../../../../pages/backoffice/BaseList'
  import BilledRecords from '../../../../backoffice/BilledRecords'

  export default {
    name: 'InvoiceRecords',
    components: {BilledRecords, BaseList, Transaction, ActionButton, InputSwitch, ModalReveal},
    data() {
      return {
        component: require('../../../../backoffice/WalletRecord')
      }
    },
    created() {
    },

    methods: {
      dataLoader(callback) {
        callback(this.records)
      }
    },
    computed: {
      records() {
        return {
          current_page: 1,
          per_page_count: 10000,
          current_page_count: 1,
          items: this.invoice.records,
          items_count: this.invoice.records.length,
          page_count: 1,
        }
      }
    },
    props: ['buttons', 'invoice'],
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-reveal-void
    .modal-footer
      .footer
        display: flex
        justify-content: space-around
</style>



// WEBPACK FOOTER //
// InvoiceRevealRecords.vue?433a16d6